import request from "@/utils/request";

export function queryParam() {
  return request({
    url: "/sys/sysParam/queryParam",
    method: "get",
  });
}

export function updateParam(data) {
  return request({
    url: "/sys/sysParam/updateParam",
    method: "post",
    data,
  });
}
